import {IonButton, IonCard, IonCardContent, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonImg, IonLabel, IonList, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRouterLink, IonRow, IonText, IonTitle, IonToolbar, RefresherEventDetail, useIonRouter, useIonViewWillEnter, useIonViewWillLeave} from '@ionic/react';
import {capitalize, productInfo} from '../utils';

import styles from "./Categories.module.scss";
import {useSideMenuOptions, useSideMenuUpdate} from "../components/sideMenu/SideMenuProvider";
import React, {Fragment, useEffect, useRef, useState} from "react";
import {tab1SideMenu} from "../components/sideMenu/PageSideMenus";
import {PageHeader} from "./PageHeader";
import {TokenItem} from "../components/TokenItem";
import {Modal} from "./Modal";
import CustomPage from "./CustomPage";
import {useStoreState} from "pullstate";
import {getPageData} from "../store/Selectors";
import {fetch_pg_7_2, Pg_7_2_Store} from "../store/Pg_7_Store";
import queryString from "query-string";
import {ContractBonusItem} from "../components/ContractBonusItem";
import {TokenEnwItem} from "../components/TokenEnwItem";
import {chevronDownCircleOutline} from "ionicons/icons";
import {PostItem} from "../components/PostItem";
import {fetch_pg_0_3} from "../store/Pg_0_Store";
import {handleCommonFetchErrors, promptBrowserToLogin} from "./Utils";
import {ActionLink} from "../components/ActionLink";
import styles_7_2 from "./Pg_7_2.module.scss";
import styles_TokenItem from "../components/TokenItem.module.scss";
import {AuthStore} from "../store/Common_Store";
import {CardFor_7_2} from "../components/CardFor_7_2";
import styles_ContractBonusDetailItem from "../components/ContractBonusDetailItem.module.scss";
import Ln_TokenPictureSetCoverImg from "./Ln_TokenPictureSetCoverImg";

const Pg_7_2 = (props) => {
    const pageRef = useRef();
    const pageName = "Pg_7_2";
    const pageId = "Pg_7_2";
    const {sideMenuOptions} = props;
    const setSideMenu: any = useSideMenuUpdate();
    const sideMenu: any = useSideMenuOptions();

    const router = useIonRouter();

    ///#region 會員
    const authStore = useStoreState(AuthStore, getPageData);
    const hasAuthed = authStore?.signBy ?? false;
    //const Item_會員 = hasAuthed ? authStore?.AuthData : undefined;
    ///#endregion

    const refIsInPage = useRef<boolean | null>(null);
    const [urlInPage, setUrlInPage] = useState<string | null>(null);

    useEffect(() => {
        setSideMenu({options: sideMenuOptions, side: "start", pageName: pageId});
    }, []);

    //#region Data Loading
    const pgData = useStoreState(Pg_7_2_Store, getPageData);
    const [amountLoaded, setAmountLoaded] = useState(20);
    const [selectedProduct, setSelectedProduct] = useState(false);

    const hasLoaded = pgData?.Root ?? false;
    const List_Sdgs課程 = hasLoaded ? pgData.Root.List_Sdgs課程 : undefined;
    const List_Sdgs課程分類 = hasLoaded ? pgData.Root.List_Sdgs課程分類 : undefined;
    const Item_Sdgs課程分類 = hasLoaded ? pgData.Root.Item_Sdgs課程分類 : undefined;

    if (hasLoaded) {
        //debugger;
    }

    const {contractId = null, isBookmark = null}: {
        contractId: string | null,
        isBookmark: string | null,
    } = queryString.parse(window.location.search) as any;

    useIonViewWillEnter(() => {
        refIsInPage.current = true;

        if (urlInPage === null || urlInPage !== window.location.toString()) {
            setUrlInPage(window.location.toString());
        }
    });

    useIonViewWillLeave(() => {
        refIsInPage.current = false;
    });

    useEffect(() => {
        if (window.location.pathname === '/tabs/7_2') {
            if (urlInPage === null || urlInPage !== window.location.toString()) {
                setUrlInPage(window.location.toString());
            }
        }
    }, [window.location.toString()]);

    useEffect(() => {
        if (urlInPage == null) { //skip
            return;
        }

        (async () => {
            const {contractId = null, isBookmark = null}: {
                contractId: string | null,
                isBookmark: string | null,
            } = queryString.parse(window.location.search) as any;
            let errorObj = await fetch_pg_7_2({
                p1: contractId,
                p2: !!isBookmark,
            });
            handleCommonFetchErrors(router, errorObj);
        })();
    }, [urlInPage]);

    let reload = async (event: CustomEvent<RefresherEventDetail> | null) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        const {contractId = null, isBookmark = null}: {
            contractId: string | null,
            isBookmark: string | null,
        } = queryString.parse(window.location.search) as any;
        let errorObj = await fetch_pg_7_2({
            p1: contractId,
            p2: !!isBookmark,
        });
        handleCommonFetchErrors(router, errorObj);
        event?.detail?.complete();
    }

    // //#region Hash on changes
    // const {contractId = null, userId = null}: {
    //     contractId: string | null,
    //     userId: string | null,
    // } = queryString.parse(window.location.search) as any;
    // const pageHash = useRef<string>(`${contractId ?? ""},${userId ?? ""}`);
    // if (pageHash.current !== `${contractId ?? ""},${userId ?? ""}`) {
    //     pageHash.current = `${contractId ?? ""},${userId ?? ""}`;
    //     reload(null);
    // }
    // //#endregion
    //

    //#endregion

    return (
        <IonPage id={pageId} key={pageId}>
            <CustomPage name={pageId} sideMenu={false} sideMenuPosition="start" backButton={true} backButtonPath={"/tabs/7_1"}>
                <IonRefresher slot="fixed" onIonRefresh={reload}>
                    <IonRefresherContent
                        pullingIcon={chevronDownCircleOutline}
                        pullingText="Pull to refresh"
                        refreshingSpinner="circles"
                        refreshingText="Refreshing...">
                    </IonRefresherContent>
                </IonRefresher>

                {hasLoaded &&
                    <Fragment>
                        {List_Sdgs課程.length === 0 && List_Sdgs課程分類.length === 0 ?
                            <>
                                <IonGrid>
                                    <IonRow>
                                        <IonCol className="ion-justify-content-center ion-text-center w100 ion-padding">
                                            學習SDGs暫無資料
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </> : <Fragment>
                                {contractId && Item_Sdgs課程分類 &&
                                    <IonGrid className="padlr16px">
                                        <IonList>
                                            <IonRow>
                                                <ActionLink link={`/tabs/7_2`} noLink={true}>
                                                    現在位置: <IonChip>{Item_Sdgs課程分類.顯示名稱}</IonChip>
                                                </ActionLink>
                                            </IonRow>
                                        </IonList>
                                    </IonGrid>
                                }
                                {isBookmark &&
                                    <IonGrid className="padlr16px">
                                        <IonList>
                                            <IonRow>
                                                <ActionLink link={`/tabs/7_2`} noLink={true}>
                                                    現在位置: <IonChip className={styles_7_2.bookmarkChip}>標註的</IonChip>
                                                </ActionLink>
                                            </IonRow>
                                        </IonList>
                                    </IonGrid>
                                }
                                <IonGrid className="padlr16px">
                                    <IonList>
                                        <IonRow>

                                            <Fragment key={'ALL'}>
                                                <ActionLink link={`/tabs/7_2`} onClick={()=>{
                                                    window.setTimeout(reload, 1);
                                                }}>
                                                    <IonChip>ALL</IonChip>
                                                </ActionLink>
                                            </Fragment>

                                            {List_Sdgs課程分類.map(item => (
                                                // <ActionLink link={`/tabs/1_2/${item.合約Id}`} className={styles.categoryContainer} key={item.合約Id}>
                                                //     <div className={styles.categoryInner}>
                                                //         {Ln_ContractPictureSetCoverImg({
                                                //             圖片組: item.圖片組,
                                                //             名稱: 'cover',
                                                //         })}
                                                //         <div><p>{capitalize(item.Name)}</p></div>
                                                //     </div>
                                                // </ActionLink>
                                                <Fragment key={item.Sdgs課程分類Id}>
                                                    <ActionLink link={`/tabs/7_2?contractId=${item.Sdgs課程分類Id}`} onClick={()=>{
                                                        window.setTimeout(reload, 1);
                                                    }}>
                                                        <IonChip>{item.顯示名稱}</IonChip>
                                                    </ActionLink>
                                                </Fragment>
                                            ))}

                                            <Fragment key={"isBookmark"}>
                                                <ActionLink link={`/tabs/7_2?isBookmark=1`} onClick={()=>{
                                                    window.setTimeout(reload, 1);
                                                }}>
                                                    <IonChip className={styles_7_2.bookmarkChip}>標註的</IonChip>
                                                </ActionLink>
                                            </Fragment>
                                        </IonRow>
                                    </IonList>
                                </IonGrid>

                                {List_Sdgs課程.length === 0 ?
                                    <>
                                        <IonGrid>
                                            <IonRow>
                                                <IonCol className="ion-justify-content-center ion-text-center w100 ion-padding">
                                                    目前分類，並沒有任何資料，請過一段時間再回來看看！
                                                </IonCol>
                                            </IonRow>
                                        </IonGrid>
                                    </> : <>
                                        <IonGrid className="ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom" onClickCapture={(ev) => {
                                            if (!hasAuthed) {
                                                promptBrowserToLogin();
                                                ev.stopPropagation();
                                                return false;
                                            }
                                            return true;
                                        }}>
                                            {/*click={() => handleShowModal(item)}*/}
                                            {List_Sdgs課程.map((item, index) => {
                                                return <Fragment key={item.Sdgs課程Id}>
                                                    <CardFor_7_2 Item_Sdgs課程={item}/>
                                                </Fragment>
                                            })}
                                        </IonGrid>
                                    </>}

                            </Fragment>}
                    </Fragment>}
            </CustomPage>
        </IonPage>
    );
};

export default Pg_7_2;
